export enum ImportType {
    DailySales = 'DAILY_SALES',
    OpsHierarchy = 'OPS_HIERARCHY',
    Top20 = 'TOP20',
    CategorySurvey = 'CATEGORY_SURVEY',
    SpecialProjectSurvey = 'SPECIAL_PROJECT_SURVEY',
    PriceGroups = 'PRICE_GROUPS',
    DailySalesHistoricalManualOverride = 'DAILY_SALES_HISTORICAL_MANUAL_OVERRIDE',
    RestrictedSkuList = 'RESTRICTED_SKU_LIST',
}

export interface ProcessResult {
    success: boolean;
    message: string;
    errors?: string[];
    recordsProcessed?: number;
    logId: string;
}
